<template>
  <v-container>
  <v-data-table
      loading-text="Loading... Please wait"
      :loading="loadingNotes"
      class="users-table elevation-0"
      :headers="headersNote"
      :items="notes"
      :options.sync="paginationNotes"
      :footer-props="footerOptions"
      :page.sync="currentPage"
      :server-items-length="totalItems"
      :items-per-page-options="rowsPerPageItems"
      mobile-breakpoint="0"
  >
    <template v-slot:item.content="{ item }">
      <v-edit-dialog
          large
          @save="updateNote(item)"
          persistent
          :return-value.sync="item.content"
      > {{ item.content }}
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            icon
          >
            <v-icon size="18px" color="fontDefault" class="mb-1">edit</v-icon>
          </v-btn> 
        </template>
        <span>{{ languageData.labels.edit }}</span>
      </v-tooltip>
        <template v-slot:input>
          <v-textarea
              class="mt-5"
              v-model="item.content"
              :label="languageData.labels.editNote"
              outlined
          ></v-textarea>
        </template>
      </v-edit-dialog>
    </template>
    <template v-slot:item.date="{ item }">
      {{ item.date }}
    </template>
    <template v-slot:item.actions="{ item }">
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
              v-bind="attrs"
              v-on="on"
              @click="showDeleteNoteModal(item)"
              icon>
            <v-icon color="fontDefault">delete</v-icon>
          </v-btn>
        </template>
        <span>Delete</span>
      </v-tooltip>
    </template>
    <ModalInfo :typeInfo="typeInfoNoteSave" :headModal="headInfoNoteSave" :btnAgreeText="languageData.btnAgreeText" :visDisAgreeBtn="false" @clicked="hideModal" :show-modal="isNoteSave" :text-modal="textInfoNoteSave"></ModalInfo>
  </v-data-table>
    <ModalInfo :visDisAgreeBtn="true" @doOperation="removeNote(notes.indexOf(noteToDelete), noteToDelete.id)"  :typeInfo="'info'" :btnDisAgreeText="languageData.modalDeleteNote.btnDisAgreeText" :headModal="languageData.modalDeleteNote.head" :btnAgreeText="languageData.btnAgreeText" @clicked="hideModalDeleteNote" :show-modal="isShowModalDeleteNote" :text-modal="languageData.modalDeleteNote.textInfo + ' ' + noteToDelete.id"></ModalInfo>
  </v-container>
</template>

<script type="text/javascript">
import {mapActions, mapState} from "vuex";
import ModalInfo from "../../../components/ModalInfo/ModalInfo";
import eventBus from "../../../event-bus/eventBus";

  export default {
    name: "NotesTable",
    props: {
      noteableType: String
    },
    components: {
      ModalInfo
    },
    data() {
      return {
        deletedNoteId: [],
        noteToDelete: {},
        footerOptions: {
          'items-per-page-options': [20, 50, 100],
          'disablePagination': false
        },
        currentPage: 1,
        notes: []
      }
    },
    computed: {
      ...mapState("getNotes", {
        notesReceive: state => state.dataReceive,
        totalItems: state => state.pagination.totalItems,
        rowsPerPageItems: state => state.pagination.rowsPerPage,
        headers: state => state.headers,
        sortBy: state => state.pagination.sortBy,
        loadingNotes: state => state.loadingNotes
      }),
      ...mapState("saveNote", {
        isNoteSave: state => state.isNoteSave,
        textInfoNoteSave: state => state.textInfoNoteSave,
        headInfoNoteSave: state => state.headInfoNoteSave,
        typeInfoNoteSave: state => state.typeInfoNoteSave
      }),
      ...mapState("deleteNote", {
        isShowModalDeleteNote: state => state.isShowModalDeleteNote
      }),
      ...mapState("getNoteHeaders", {
        headersNote: state => state.headersNote
      }),
      ...mapState("saveNote", {
        isNoteSave: state => state.isNoteSave,
        textInfoNoteSave: state => state.textInfoNoteSave,
        headInfoNoteSave: state => state.headInfoNoteSave,
        typeInfoNoteSave: state => state.typeInfoNoteSave
      }),
      paginationNotes: {
        set: function(value) {
          this.searchNotes(value);
        },
        get: function() {
          return this.$store.state.getNotes.pagination;
        }
      },
    },
    methods: {
      ...mapActions("getNoteHeaders", ["getNoteHeaders"]),
      ...mapActions("deleteNote", ["deleteNote", "updateVisibleModalDeleteNote"]),
      ...mapActions("updateNote", ["updateNoteData"]),
      ...mapActions("getNotes", ["getNotes"]),
      showDeleteNoteModal: function(item) {
        this.noteToDelete = item;
        this.updateVisibleModalDeleteNote(true);
      },
      hideModalDeleteNote: function() {
        this.updateVisibleModalDeleteNote(false);
      },
      searchNotes: function(valueSearch={}, filters=false) {
        valueSearch.language = this.getCurrentLanguage;
        valueSearch.filters = filters;
        valueSearch.noteableType = this.noteableType;
        this.getNotes({ valueSearch });
        if(filters) {
          this.currentPage = 1;
        }
      },
      updateNote: function(item) {
        let id = item.id;
        let content = item.content;
        this.updateNoteData({ creds: { id, content } });
      },
      removeNote: function(index, id) {
        this.notes.splice(index, 1);
        this.deleteNote({ creds: { id } });
      },
      hideModal: function()
      {
        this.updateVisibleModalNote(false);
      }
    },
    mounted() {
      const language = this.getCurrentLanguage;

      this.getNoteHeaders({creds: {language}});

      eventBus.$on("getNotesSuccess", (notesData) => {
        this.notes = notesData;
      });
      eventBus.$on("saveNoteSuccess", () => {
        this.searchNotes({});
      });
    },
    beforeDestroy() {
      eventBus.$off("saveNoteSuccess");
    }
  }
</script>